import React from 'react';
import { motion } from 'framer-motion';
import { FiHeart, FiMapPin } from 'react-icons/fi';

export default function SmallGoldPublic({ data, color }) {
    const title = data?.titulo || data?.title || 'Ativo Gold';
    const price = data?.preco || data?.price;
    const mainImage = data?.imagensDestaque?.[0] || data?.image || 'https://images.unsplash.com/photo-1580587767503-3997489ccd50';

    return (
        <motion.div whileHover={{ y: -5 }} className="bg-white rounded-[2.5rem] overflow-hidden shadow-lg border border-gray-100 group">
            <div className="relative h-48 overflow-hidden">
                <img src={mainImage} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <button className="absolute top-4 right-4 p-2 rounded-full bg-white/20 backdrop-blur-md text-white hover:text-red-500 transition-colors"><FiHeart /></button>
            </div>
            <div className="p-6 space-y-2">
                <div className="flex items-center gap-2 text-[9px] font-black uppercase tracking-widest text-gray-400">
                    <FiMapPin style={{ color }} /> {data?.bairro || 'Curitiba'}
                </div>
                <h4 className="text-sm font-black text-gray-900 uppercase truncate">{title}</h4>
                <div className="text-xl font-black" style={{ color }}>
                    {typeof price === 'number' ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : price}
                </div>
            </div>
        </motion.div>
    );
}